/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ProjectStatusDto interface.
 */
export function instanceOfProjectStatusDto(value) {
    return true;
}
export function ProjectStatusDtoFromJSON(json) {
    return ProjectStatusDtoFromJSONTyped(json, false);
}
export function ProjectStatusDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'value': json['value'] == null ? undefined : json['value'],
        'statusDescription': json['statusDescription'] == null ? undefined : json['statusDescription'],
    };
}
export function ProjectStatusDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'value': value['value'],
        'statusDescription': value['statusDescription'],
    };
}
